/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    AGENTKB_title: "Support clients",
    AGENTKB_updatedAt: "Mis à jour à {0} · toutes les minutes",
    AGENTKB_groupPlaceholder: "N° de groupe",
    AGENTKB_userPlaceholder: "E-mail d'un utilisateur",
    AGENTKB_searchPlaceholder: "Rechercher dans les questions",
    AGENTKB_userAll: "Toutes ses questions",
    AGENTKB_userClear: "Retirer le filtre utilisateur",
    AGENTKB_usersTitle: "Support clients — par utilisateur",
    AGENTKB_usersFilter: "Filtrer par e-mail ou n° de groupe",
    AGENTKB_usersQuestions: "Questions",
    AGENTKB_usersVotes: "Votes",
    AGENTKB_usersLast: "Dernière question",
    AGENTKB_usersSampled:
        "Groupe, votes et dernière question comptés sur les 200 derniers " +
        "échanges de la période.",
    AGENTKB_usersOpenGeneral: "Ouvrir dans la vue générale",
    AGENTKB_usersClose: "Fermer",
    AGENTKB_articleAll: "Toutes les questions auxquelles cet article a servi",
    AGENTKB_articleFilter: "Article : {0}",
    AGENTKB_articleClear: "Retirer le filtre article",
    AGENTKB_kpiCache: "+ {0} en cache",
    AGENTKB_helpScout: "Ouvrir le ticket HelpScout",
    AGENTKB_threadShow: "Voir toute la conversation",
    AGENTKB_threadHide: "Revenir à l'échange seul",
    AGENTKB_threadLoading: "Chargement…",
    AGENTKB_threadClosed: "Conversation archivée le {0}",
    AGENTKB_threadOpen: "Conversation non close",
    AGENTKB_threadSupport: "Transmis au support : {0}",
    AGENTKB_conversationsTitle: "Support clients — conversations",
    AGENTKB_conversationsFirst: "Première question",
    AGENTKB_conversationsTurns: "Tours",
    AGENTKB_conversationsTransfers: "Transferts",
    AGENTKB_conversationsClosed: "Archivée",
    AGENTKB_conversationsNotClosed: "Non close",
    AGENTKB_conversationsKind_all: "Toutes",
    AGENTKB_conversationsKind_down: "Avec un pouce en bas",
    AGENTKB_conversationsKind_sent: "Transmises au support",
    AGENTKB_usageTitle: "Support clients — usage",
    AGENTKB_usageByModel: "Par modèle",
    AGENTKB_usageByGroup: "Par groupe",
    AGENTKB_usageModel: "Modèle",
    AGENTKB_usageInput: "Entrée",
    AGENTKB_usageOutput: "Sortie",
    AGENTKB_usageCache: "Cache",
    AGENTKB_usagePerQuestion: "Jetons par question",
    AGENTKB_usageNoModel: "Sans modèle (refus, erreur)",
    AGENTKB_usageNoGroup: "Sans groupe",
    AGENTKB_usageGroupAll: "Les questions de ce groupe",
    AGENTKB_period7: "7 jours",
    AGENTKB_period30: "30 jours",
    AGENTKB_period90: "90 jours",
    AGENTKB_period365: "12 mois",
    AGENTKB_useful: "Utile",
    AGENTKB_notUseful: "Pas utile",
    AGENTKB_voteRate: "{0} votes sur {1} réponses, soit {2} % des réponses notées",
    AGENTKB_kpiQuestions: "Questions",
    AGENTKB_kpiConversations: "Conversations",
    AGENTKB_kpiSupport: "Transférées au support",
    AGENTKB_kpiSupportFailed: "{0} annoncée(s) mais jamais parties",
    AGENTKB_kpiDuration: "Temps de réponse moyen",
    AGENTKB_kpiTokens: "Jetons consommés",
    AGENTKB_chartQuestions: "Questions par jour",
    AGENTKB_servedTitle: "Articles les plus servis",
    AGENTKB_rejectedTitle: "Articles les plus rejetés",
    AGENTKB_empty: "Rien sur la période.",
    AGENTKB_sampled: "Articles comptés sur les 200 derniers échanges de la période.",
    AGENTKB_ratingsTitle: "Réponses",
    AGENTKB_filter_all: "Toutes",
    AGENTKB_filter_up: "Utiles",
    AGENTKB_filter_down: "Pas utiles",
    AGENTKB_filter_none: "Sans vote",
    AGENTKB_filter_sent: "Transférées",
    AGENTKB_filter_failed: "Transferts en échec",
    AGENTKB_columnDate: "Date",
    AGENTKB_columnUser: "Utilisateur",
    AGENTKB_columnGroup: "Groupe",
    AGENTKB_columnQuestion: "Question",
    AGENTKB_columnArticle: "Article",
    AGENTKB_columnRating: "Avis",
    AGENTKB_columnReason: "Raison",
    AGENTKB_columnComment: "Commentaire",
    AGENTKB_ratingUp: "Utile",
    AGENTKB_ratingDown: "Pas utile",
    AGENTKB_detailTitle: "Échange n° {0}",
    AGENTKB_close: "Fermer",
    AGENTKB_detailPage: "Écran",
    AGENTKB_detailSupport: "Support",
    AGENTKB_detailTechnical: "Technique",
    AGENTKB_detailAnswer: "Réponse",
    AGENTKB_supportSent: "Transféré le {0}",
    AGENTKB_supportFailed: "Annoncé, jamais parti"
};
